// extracted by mini-css-extract-plugin
export default {"header":"PageManager_header__l9WJp","containerBg":"PageManager_containerBg__+sUys"};